import React from 'react';
import TruthsortingLogo from 'url:./assets/TruthsortingLogo.svg';
import OutcomeBanner from './OutcomeBanner';
import { TruthsortingStore } from '../_puzzles/Truthsorting/TruthsortingStore';

const TruthsortingPreview = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className="previewTile puzzleTile truthsortingPreview" onClick={onClick}>
      <div className="truthsortingPreview">
        <div className="puzzleTitle">Truthsorting</div>
        <div className="previewImageContainer">
          <img className="truthsortingIcon" src={TruthsortingLogo}/>
          <OutcomeBanner store={TruthsortingStore as any} />
        </div>
      </div>
    </div>
  );
};

export default TruthsortingPreview;